(function () {
  var header = document.querySelector('[data-lm-header]');
  if (!header) return;

  var scrolledClass = 'lm-header--scrolled';
  var scrollThreshold = 50;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      if (window.scrollY > scrollThreshold) {
        header.classList.add(scrolledClass);
      } else {
        header.classList.remove(scrolledClass);
      }
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mobile menu toggle
  var hamburger = document.querySelector('[data-lm-hamburger]');
  var mobileMenu = document.querySelector('[data-lm-mobile-menu]');
  var mobileClose = document.querySelector('[data-lm-mobile-close]');
  var mobileOverlay = document.querySelector('[data-lm-mobile-overlay]');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('lm-mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var firstFocusable = mobileMenu.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('lm-mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (hamburger) hamburger.focus();
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      return;
    }
    if (e.key !== 'Tab' || !mobileMenu || !mobileMenu.classList.contains('lm-mobile-menu--open')) return;
    var focusable = mobileMenu.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
